module.exports = __webpack_public_path__ + "media/images/logo/orangeclicks-w-1425f9e24a715de30e002873beddbcf2.png";